import { EmployeePermissions, UserRole } from '@synergy/models';
import { hasRole } from '@synergy/utils';

import { User } from '../models/user';

/**
 * Whether the user sees the orders of the whole company, not only their own:
 * the shop admin, and whoever was given the company's orders to see. The
 * order endpoints decide by the same rule, so the filter by person and "Meine"
 * follow it too (#2328 R-248).
 */
export const seesCompanyOrders = (user?: User | null): boolean =>
    hasRole(UserRole.ShopAdmin, user) || !!user?.employeePermissions?.includes(EmployeePermissions.EmployeeOrders);
